export abstract class BaseFilterComponent {
  change: (filter: any) => void;
}
